module.exports = __webpack_public_path__ + "img/cqfw2.86f22ce2.png";